export const SUPPORTED_LANGUAGES = [`en`] as const
export const DEFAULT_LANGUAGE = `en` as const
export const FALLBACK_LANGUAGE = `en` as const
export const DEFAULT_NAMESPACE = `common` as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const ISO_LANGUAGE_CODES = {
  en: `en-GB` as const
} satisfies Record<SupportedLanguage, string>

export const SUPPORTED_LOCALES = Object.values(ISO_LANGUAGE_CODES)

export type ISO_LANGUAGE_CODE = (typeof ISO_LANGUAGE_CODES)[keyof typeof ISO_LANGUAGE_CODES]
